export const RECORD_METHOD = [
  {
    id: 1,
    title: ["무엇으로", " 추억을 남길까요?"],
    options: ["키보드", "목소리"],
  },
];

export const COMMENT_METHOD = [
  {
    id: 2,
    title: ["어떤 방식으로", " 답글을 남길까요?"],
    options: ["덕담 카드", "목소리", "키보드"],
  },
];

export const EDIT_MEMORY = [
  {
    id: 3,
    title: ["어떻게", " 추억을 수정할까요?"],
    options: ["내용 수정하기", "처음부터 다시 말하기"],
  },
];
